import { useTranslations } from "next-intl";
import styles from "./styles.module.css";
import { DescriptionTitleProps } from "types/DescriptionTitle.type";

export default function H3({ translation, text, style }: DescriptionTitleProps) {
  const t = useTranslations(translation);

  return (
    <h3 className={`${style || ""} ${styles.h3}`}>
      {t.rich(text, {
        span: (chunks) => (
          <span className="gradient-text-color">{chunks}</span>
        ),
      })}
    </h3>
  );
}
